import * as React from 'react';
import { Box, Flex } from '../../CommonUI/Layout';
import { StyleSheet, css } from 'aphrodite';
import { Exclamation, Close } from '../../Assets/images/svg';
import { Text, HtmlText } from 'ilenia';

export interface Interpolations {
    [key: string]: string;
}

interface NotificationBoxProps extends React.HTMLProps<HTMLAnchorElement> {
    text?: string;
    htmlText?: string;
    interpolations?: Interpolations;
    onClick?: () => void;
}

export const NotificationBox: React.SFC<NotificationBoxProps> = (props) => {
    const { text, htmlText, onClick } = props;
    return (
        <Box pl={20} mt={0}>
            <div className={css(styles.box)}>
                <Flex
                    flexDirection="row"
                    alignItems="flex-start"
                    justifyContent="start"
                >
                    <Box mt={0} p={16} width="auto">
                        <Exclamation />
                    </Box>
                    <Box mt={0} p={16}>
                        {text ?
                            <Text id={text} interpolations={props.interpolations}/> :
                            <HtmlText id={htmlText!} interpolations={props.interpolations!}/>
                        }
                    </Box>
                    <Box mt={0} p={16} width="auto" onClick={onClick} className={css(styles.clickable)}>
                        <Close />
                    </Box>
                </Flex>
            </div>
        </Box>
    );
};

const styles = StyleSheet.create({
    box: {
        maxWidth: '800px',
        fontSize: '14px',
        color: '#674808',
        backgroundColor: '#fde8a6',
    },
    text: {
        lineHeight: '1.43',
        letterSpacing: 'normal',
    },
    clickable: {
        ':hover': {
            cursor: 'pointer'
        },
    }
});



// WEBPACK FOOTER //
// ./src/CommonUI/UI/NotificationBox.tsx